import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

export default function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Verificar si el usuario ya aceptó las cookies
        const hasAccepted = localStorage.getItem('evelux_cookies_accepted');
        if (!hasAccepted) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('evelux_cookies_accepted', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-fade-in-up">
            <div className="max-w-7xl mx-auto bg-gray-900/95 backdrop-blur-md border border-gray-800 rounded-3xl p-6 md:p-8 shadow-2xl flex flex-col md:flex-row items-center justify-between gap-6 md:gap-10">

                <div className="flex items-start gap-5">
                    <div className="bg-blue-600/20 p-3 rounded-2xl flex-shrink-0 mt-1">
                        <Cookie className="text-blue-400 w-8 h-8" />
                    </div>
                    <div>
                        <h3 className="text-white font-bold text-lg mb-2">Valoramos tu privacidad</h3>
                        <p className="text-gray-400 text-sm leading-relaxed max-w-3xl">
                            Utilizamos cookies esenciales y de terceros para personalizar tu experiencia en Evelux, analizar nuestro tráfico web y brindarte el mejor servicio posible para agendar tus viajes. Al continuar navegando, consideramos que aceptas su uso.
                        </p>
                        <div className="mt-4 flex gap-4 text-sm font-semibold">
                            <Link to="/legal/cookies" className="text-blue-400 hover:text-blue-300 transition-colors">
                                Leer Política de Cookies
                            </Link>
                            <span className="text-gray-600">•</span>
                            <Link to="/legal/privacidad" className="text-blue-400 hover:text-blue-300 transition-colors">
                                Leer Política de Privacidad
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="flex-shrink-0 w-full md:w-auto">
                    <button
                        onClick={handleAccept}
                        className="w-full md:w-auto bg-blue-600 hover:bg-blue-500 text-white font-black py-4 px-10 rounded-2xl uppercase text-xs tracking-[0.2em] transition-all transform hover:scale-105 shadow-xl shadow-blue-900/50"
                    >
                        Aceptar Todas
                    </button>
                    <button
                        onClick={() => setIsVisible(false)}
                        className="absolute top-4 right-4 text-gray-400 hover:text-white md:hidden"
                    >
                        <X size={20} />
                    </button>
                </div>
            </div>
        </div>
    );
}
